import OpenChat from '~/src/components/OpenChatLink';

import BaseErrorToast from './BaseErrorToast';

const RecalculateFallDown = ({ ...props }): JSX.Element => <BaseErrorToast {...props}>
    <>
        Произошла ошибка, попробуйте повторить действие, перезагрузите страницу или&nbsp;напишите в&nbsp;<OpenChat>чат&nbsp;поддержки</OpenChat>
    </>
</BaseErrorToast>;

export default RecalculateFallDown;
